import { FormEvent, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Hcaptcha, HcaptchaHandle, isCaptchaRequired, SubmitButton } from '../../components/common'
import { api, ApiError } from '../../lib/api'
import { getConfig, trackEvent } from '../../lib/config'
import { AuthAlerts, AuthLayout, AuthLogo, LoginForm } from './AuthLayout'

export default function ConfirmationNewPage() {
  const config = getConfig()
  const [email, setEmail] = useState('')
  const [notice, setNotice] = useState<string | null>(config.flash.notice ?? null)
  const [errors, setErrors] = useState<string[]>(config.flash.alert ? [config.flash.alert] : [])
  const [submitting, setSubmitting] = useState(false)
  const [captchaSolved, setCaptchaSolved] = useState(false)
  const captchaRef = useRef<HcaptchaHandle | null>(null)
  const canSubmit = !submitting && (captchaSolved || !isCaptchaRequired())

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    if (submitting) {
      return
    }
    setSubmitting(true)
    setErrors([])
    setNotice(null)
    try {
      const result = await api.post<{ notice: string }>('/professionals/confirmation', {
        professional: { email },
        'h-captcha-response': captchaRef.current?.getResponse() ?? '',
      })
      trackEvent('Confirmation Resent')
      setNotice(result.notice)
    } catch (requestError) {
      const body = requestError instanceof ApiError ? (requestError.body as { errors?: string[] } | null) : null
      setErrors(body?.errors ?? ['Ocurrió un error, inténtalo nuevamente'])
      captchaRef.current?.reset()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout>
      <AuthAlerts notices={notice ? [notice] : []} errors={errors} />
      <LoginForm onSubmit={(event) => void handleSubmit(event)}>
          <AuthLogo />
          <div className="row text-center">
            <h4>Reenviar instrucciones de confirmación</h4>
            <p>Si no recibiste el correo de confirmación, escribe aquí tu email para enviarte las instrucciones de nuevo.</p>
          </div>
          <div className="form-group col-xs-12">
            <input
              type="email"
              id="professional_email"
              className="form-control"
              placeholder="email"
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
            <i className="fa fa-user" />
          </div>
          <Hcaptcha theme="light" handleRef={captchaRef} form="confirmation" onResponseChange={setCaptchaSolved} />
          <div className="form-group col-xs-12">
            <SubmitButton label="Reenviar instrucciones" block disabled={!canSubmit} />
          </div>
          <section>
            <Link to="/professionals/sign_in">Iniciar sesión</Link>
            <br />
            <Link to="/professionals/password/new">¿Ha olvidado tu contraseña?</Link>
            <br />
            <Link to="/professionals/sign_up">¿Quieres una nueva cuenta?</Link>
          </section>
      </LoginForm>
    </AuthLayout>
  )
}
